import React, { useState, useEffect } from "react";

export const svg = `<svg width="64" height="64" viewbox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#settings-delete-user-a)"><circle cx="32" cy="32" r="32" fill="#272A30"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M16 42.002v-1.158C16 36.293 26.66 34 32 34s16 2.293 16 6.844v1.158C44.351 46.859 38.542 50 32 50s-12.351-3.141-16-7.998ZM32 14c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Z" fill="#7F838B"></path><circle cx="54" cy="10" r="12" fill="#DD344A" stroke="#181B21" stroke-width="4"></circle><path d="M50.293 7.707a1 1 0 0 1 1.414-1.414L54 8.586l2.293-2.293a1 1 0 1 1 1.414 1.414L55.414 10l2.293 2.293a1 1 0 0 1-1.414 1.414L54 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L52.586 10l-2.293-2.293Z" fill="#181B21"></path></g><defs><clipPath id="settings-delete-user-a"><path fill="#fff" d="M0 0h64v64H0z"></path></clipPath></defs></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
